export const colors = {
  BLACK: 'black',
  BLUE: '#135a9a',
  GREY: '#727272',
  GREY_BORDER: '#ececec',
  LINK: '#0c406e',
  MAROON: 'maroon',
}
